import { render, staticRenderFns } from "./switchOrganizationList.vue?vue&type=template&id=0ed857a3&scoped=true&"
import script from "./switchOrganizationList.vue?vue&type=script&lang=js&"
export * from "./switchOrganizationList.vue?vue&type=script&lang=js&"
import style0 from "./switchOrganizationList.vue?vue&type=style&index=0&id=0ed857a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed857a3",
  null
  
)

export default component.exports